export default __webpack_public_path__ + "static/media/Category_385x420 copy 4.a480256e.jpg";